import FileTypes from 'Browser/FileTypes';
import {BuildBasics} from 'Common/BuildBasics';
import {Id} from 'Common/Id';
import { SiteBasics } from 'Common/SiteBasics';
import {Location} from 'Common/config/PageConfigTypes';
import * as imageSize from 'Shared/model/ImageSizes';
import { ImageSchema, ImageSize } from 'Shared/model/basic';

export interface FullLink
{
	url:string;
	id?:string;
}

export interface PartialLink
{
	partial:string;
	id?:string;
}

export interface ILinks
{
	js: FullLink[];
	css: FullLink[];
	prefixes: {resources?:string};
}


export class Urls
{
	constructor(
		private build:BuildBasics,
		/* If undefined, assume artist GUI */
		private site?:SiteBasics
	) { }

	/* Some test systems use a mix of dev images and production images (readonly). */
	imageUrl(assetFolder:string,hash:string,size:string,fileType:string,useProduction:boolean,proxyProductionAssets:boolean=false)
	{
		let source = `/_assets`;

		if (this.build.key=='DEV') {
			source = `/_devAssets`;
			if (useProduction)
				source = proxyProductionAssets ? `/_proxyAssets` : `https://dummy.ontoit.xyz/_assets`;
		}
		else if (!useProduction)
			/* Should be in a build or live test system here, not in prodution */
			source = `/_devAssets`;

//TODO check... could just set 'artists' as site key, if not already doing so and simplify

		const dir = this.site?.key ?? 'artists';

		return source+`/${dir}/`+assetFolder+'/'+hash+'-'+size+'.'+FileTypes.suffix(fileType);
	}

	uploadImageUrl(page:string,permission:string,formats:keyof typeof imageSize,docId:Id,location:Location):string
	{
		const encPage = encodeURIComponent(page);
		const encLocation = location==undefined ? '' : '/'+encodeURIComponent(JSON.stringify(location));

		return `/admin/imageUpload/${encPage}/${permission}/${formats}/${docId}${encLocation}`;
	}

	resourceUrl(relativeUrl:string):string
	{
		return this.buildUrl(`resources/${relativeUrl}`);
	}

	buildUrl(relativeUrl:string):string
	{
		const buildBit = this.build.storeForBuiltAssets=='production' ? '_build' : '_devBuild';
		return `/${buildBit}/`+this.build.key+'/'+relativeUrl;
	}

//XXX more of a utility function for calling imageUrl?
	createImageUrl(hash:string,fieldData:ImageSchema|undefined,assetFolder:string,imageSize:ImageSize,proxyProductionAssets?:boolean)
	{
		if (fieldData?.formats==undefined || hash==undefined )
			return undefined;

		const size = fieldData.formats[imageSize];
        if (size==null) 
			return undefined;

		const useProduction = !(fieldData['dev']);

		return this.imageUrl(assetFolder,hash,imageSize,size.format,useProduction,proxyProductionAssets);
	}
}

